<template>
  <div class="box-shadow" v-if="can_access('deal','modify')">      
    <form>
      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.name')}">
            <label>Currency Name </label><span class="message">{{ validation.firstError('formInput.name') }}</span>
            <input type="text" placeholder="Enter New Currency Name" class="form-control" v-model="formInput.name">
          </div>    
          <div class="col-sm-4 form-group" :class="{error: validation.hasError('formInput.code')}">
            <label>Currency Code </label><span class="message">{{ validation.firstError('formInput.code') }}</span>
            <input type="text" placeholder="Enter New Currency Code" class="form-control" v-model="formInput.code">
          </div>  
        </div>
        <div class="" style="display:flow-root">
          <button class=" pull-right btn btn-lg btn-info" @click="add_currency">Add</button>
        </div>  
      </div>
    </form>
  </div>
</template>
<script>
import $ from 'jquery';
import common from '@/assets/js/common.js';
import SimpleVueValidator from 'simple-vue-validator';

const Validator = SimpleVueValidator.Validator;
export default {
  name: "AddNewCurrencyForm",
  props:['forceRerender','rows'],
  mixins: [common,SimpleVueValidator.mixin],
  data(){
    return {
      formInput: {
        id:'',
        name : "",
        code: "",
        status: 1, 
        action: 'create' 
      }
    }
  },
  validators: {
    'formInput.name': function(value) {
      if(this.formInput.action != 'delete')
        return Validator.value(value).required();
    },
    'formInput.code': function(value) {
      if(this.formInput.action != 'delete')
        return Validator.value(value).required();
    },
  },
  watch: {
    'formInput.id': function(){
      if(this.formInput.status == 0) this.add_currency();
    },
  },
  methods:{
    async add_currency(e){
    e.preventDefault();
    this.$validate()
      .then(async (success) => {
        if (success) {
          const {response} = await this.call_axios('add_currency','post', this.formInput);
          //if(response.code==0){
            this.$toasted.success("Currency added successfully",{duration:1500});
            this.forceRerender(response);
          //}
        }
      });
    }
  },
  created(){
    if(typeof this.rows != 'undefined'){
      Object.assign(this.formInput, this.rows);
    }
  }
}
</script>